import { useContext, useEffect, useState } from "react";
import { Account } from "../Main";
import { fetchWithAuth } from "../Utils";
import "./PopupTutteSfide.css";
import Popup from "./Popup";

const PopupTutteSfide = ({ onClose, onAggiornaClassifica }) => {
    const { persona, showAlert } = useContext(Account);

    const [sfide, setSfide] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filtroStato, setFiltroStato] = useState("tutte");
    const [prenotazioniSfida, setPrenotazioniSfida] = useState({});

    useEffect(() => {
        caricaSfide();
    }, []);

    const caricaSfide = async () => {
        setLoading(true);
        const res = await fetchWithAuth("classifica_mobile_get_tutte_sfide.php",{}, "GET");
        if (res.ok) setSfide(res.sfide);
        setLoading(false);
    };

    const caricaPrenotazioniSfida = async (IDSfida) => {

        if (prenotazioniSfida[IDSfida]) {
            return;
        }

        const res = await fetchWithAuth(
            `classifica_mobile_get_prenotazioni_sfida.php?IDSfida=${IDSfida}`,
            {},
            "GET"
        );

        if (res.ok) {

            setPrenotazioniSfida(prev => ({
                ...prev,
                [IDSfida]: res.prenotazioni
            }));

        } else {

            showAlert(
                "Errore",
                res.error || "Errore caricamento prenotazioni"
            );
        }
    };

    const associaPrenotazione = async (IDSfida, IDPrenota) => {

    const res = await fetchWithAuth(
        "classifica_mobile_associa_prenotazione.php",
        {
            method: "POST",
            body: JSON.stringify({
                IDSfida,
                IDPrenota
            })
        }
    );

    if (res.ok) {

        showAlert(
            "Successo",
            "Prenotazione associata"
        );

        caricaSfide();
        onAggiornaClassifica();

    } else {

        showAlert(
            "Errore",
            res.error
        );
    }
};

    const sfideFiltrate = sfide.filter(sfida => {

        if (filtroStato === "tutte") return true;

        return sfida.Stato === filtroStato;
    }).sort((a,b) => new Date(b.DataCreazione) - new Date(a.DataCreazione));

    const inviaRisultato = async (idSfida, vincitoreID, vincitoreNome) => {
        if (!window.confirm("Confermare la vittoria di "+vincitoreNome+"?")) return;

        const res = await fetchWithAuth("classifica_mobile_inserisci_risultato.php", {
            method: "POST",
            body: JSON.stringify({
                IDSfida: idSfida,
                Vincitore_ID: vincitoreID
            })
        });

        if (res.ok) {
            showAlert("Successo", "Risultato inserito e classifica aggiornata");
            caricaSfide();
            onAggiornaClassifica();
        } else {
            showAlert("Errore", res.error);
        }
    };

    const ritiraSfida = async (IDSfida) => {

        if (!window.confirm("Annullare la sfida?")) return;

        const res = await fetchWithAuth(
            "classifica_mobile_ritira_sfida.php",
            {
                method: "POST",
                body: JSON.stringify({ IDSfida })
            }
        );

        if (res?.ok) {

            showAlert("Successo", "Sfida annullata");

            caricaSfide();
            onAggiornaClassifica();

        } else {

            showAlert("Errore", res?.error || "Errore");
        }
    };

    return (
        <Popup id="popup-tutte-sfide" onClose={onClose} title="Tutte le sfide">
        <div style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 20
        }}>
            <select
                value={filtroStato}
                onChange={(e) => setFiltroStato(e.target.value)}
            >
                <option value="tutte">Tutte</option>
                <option value="in_attesa">In attesa</option>
                <option value="accettata">Accettate</option>
                <option value="giocata">Giocate</option>
                <option value="rifiutata">Rifiutate</option>
                <option value="persa_automatica">Perse automatiche</option>
            </select>
        </div>

                {loading && <p>Caricamento...</p>}

                {!loading && sfideFiltrate.length == 0 && (
                    <p style={{ textAlign: "center", marginTop: 40 }}>
                        Nessuna sfida presente
                    </p>
                )}

                {sfideFiltrate.map(sfida => {
                    const vinceSfidante =
                        sfida.Stato === "persa_automatica"
                            ? true
                            : sfida.Vincitore_ID == sfida.SfidanteID;

                    const vinceSfidato =
                        sfida.Stato === "persa_automatica"
                            ? false
                            : sfida.Vincitore_ID == sfida.SfidatoID;

                    const swap =
                        sfida.Stato === "giocata" &&
                        (
                            (vinceSfidante && sfida.pos_sfidante > sfida.pos_sfidato) ||
                            (vinceSfidato && sfida.pos_sfidato > sfida.pos_sfidante)
                        );

                    return (
                        <div className="card-sfida" key={sfida.IDSfida}>
                            <h3>{sfida.sfidante_nome} vs {sfida.sfidato_nome}</h3>

                            <p>
                                Stato: <b>{sfida.Stato == "in_attesa" ? "in attesa" : sfida.Stato == "persa_automatica" ? "persa automaticamente" : sfida.Stato}</b><br />
                                Scadenza: <b>{sfida.Scadenza}</b>
                            </p>

                            {sfida.Stato == "giocata" && sfida.pren_data && (
                                <p>
                                    Giocata il: <b>{sfida.pren_data} ({sfida.pren_ora})</b>
                                </p>
                            )}

                            {sfida.IDPrenota && (
                                <p>
                                    Prenotazione:<br />
                                    <b>{sfida.pren_data}</b> – <b>{sfida.pren_ora}</b><br />
                                    Campo: <b>{sfida.pren_campo}</b>
                                </p>
                            )}

                            {persona.maestro &&
    sfida.Stato === "accettata" &&
    !sfida.IDPrenota && (

        <div style={{ marginTop: 10 }}>

            {!prenotazioniSfida[sfida.IDSfida] && (

                <button
                    className="conferma"
                    onClick={() =>
                        caricaPrenotazioniSfida(
                            sfida.IDSfida
                        )
                    }
                >
                    Cerca prenotazioni
                </button>

            )}

            {prenotazioniSfida[sfida.IDSfida] && (

                <>
                    <label>
                        Associa prenotazione:
                    </label>

                    <br />

                    <select
                        defaultValue=""
                        onChange={(e) => {

                            if (!e.target.value) {
                                return;
                            }

                            associaPrenotazione(
                                sfida.IDSfida,
                                e.target.value
                            );
                        }}
                    >

                        <option value="">
                            -- seleziona --
                        </option>

                        {prenotazioniSfida[
                            sfida.IDSfida
                        ].map(p => (

                            <option
                                key={p.IDPrenota}
                                value={p.IDPrenota}
                            >
                                {p.match_sfida == 1
                                    ? "⭐ "
                                    : ""}

                                {p.data}
                                {" "}
                                {p.ora}
                                {" - "}
                                {p.nomeCampo}
                                {" - "}
                                {p.giocatore1_nome}

                                {p.giocatore2_nome
                                    ? ` / ${p.giocatore2_nome}`
                                    : ""}
                            </option>

                        ))}

                    </select>
                </>
            )}

        </div>
)}

                            {(sfida.Stato === "giocata" ||
                                sfida.Stato === "rifiutata" ||
                                sfida.Stato === "persa_automatica") && (
                                <>

                                    {sfida.Stato === "rifiutata" ? (
                                        <p>
                                            Esito: <b>Sfida rifiutata</b>
                                        </p>
                                    ) : (
                                        <p>
                                            Vincitore:{" "}
                                            <b>
                                                {vinceSfidante
                                                    ? sfida.sfidante_nome
                                                    : sfida.sfidato_nome}
                                            </b>
                                        </p>
                                    )}

                                    <p>
                                        Nuove posizioni:<br />
                                        {sfida.sfidante_nome}: {sfida.pos_sfidante}
                                        <br />
                                        {sfida.sfidato_nome}: {sfida.pos_sfidato}
                                    </p>

                                </>
                            )}
                            {persona.maestro && sfida.Stato == "accettata" && sfida.IDPrenota && (
                                <div style={{ marginTop: 10 }}>
                                    <label>Risultato:</label><br />
                                    <button
                                        className="conferma"
                                        onClick={() => inviaRisultato(sfida.IDSfida, sfida.SfidanteID, sfida.sfidante_nome)}
                                        style={{ marginBottom: 8 }}
                                    >
                                        Vince {sfida.sfidante_nome}
                                    </button>
                                    <button
                                        className="conferma"
                                        onClick={() => inviaRisultato(sfida.IDSfida, sfida.SfidatoID, sfida.sfidato_nome)}
                                        style={{ marginBottom: 20 }}
                                    >
                                        Vince {sfida.sfidato_nome}
                                    </button>
                                </div>
                            )}
                            {persona.maestro && sfida.Stato != "persa_automatica" && sfida.Stato != "giocata" && (
                                <button
                                    className="rimuovi"
                                    onClick={() => ritiraSfida(sfida.IDSfida)}
                                >
                                    Annulla sfida
                                </button>
                            )}
                        </div>
                    );
                })}
        </Popup>
    );
};

export default PopupTutteSfide;
